
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
//import { NgwWowService } from 'ngx-wow';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { MagnifyFieldSearchComponent } from 'src/app/shared/components/magnify-field-search/magnify-field-search.component';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'create-doa-config',
  templateUrl: './create-doa-config.component.html',
  styleUrls: ['./create-doa-config.component.css']
})
export class CreateDOAConfigComponent implements OnInit, AfterViewInit {
  isBright: boolean = true;
  isOpenDoctypeModel: boolean = true;
  selectedDocumentType: any = { docTypeId: 0, docTypeName: '', isCommentMandatory: false };
  @ViewChild('documentTypeModal') documentTypeModal: ElementRef;
  modalReference: any;
  Rule_desc: any;
   frmRulesave: FormGroup;
  csrfToken: string = '';

  @ViewChild('autosize') autosize: CdkTextareaAutosize;


  docTypeList: { docTypeId: number, docTypeName: string, isCommentMandatory: false }[] = [];
  RoleList: { Id: number, Name: string }[] = [];
  processTypeList: { Id: number, Name: string }[] = [];
  fieldList: { Id: number, Name: string }[] = [];


  processTypeList_appr: { Id: number, Name: string }[] = [];
  processTypeList_rej: { Id: number, Name: string }[] = [];
  processTypeList_forwd: { Id: number, Name: string }[] = [];

  documentType_MST: any;
  selectedProcess: number = 0;

  doa_matrixlist: { Id: number, Name: string }[] = [];
  doa_Rulelevellist: { Id: number, Name: string }[] = [];
  doa_Typelist: { Id: number, Name: string }[] = [];


  selected_doa_Type: any
  selected_doa_Matrix: any;
  selected_queue: any;
  selected_approved_queue: any;
  selected_rejected_queue: any;
  selected_Forward_queue: any;
  Selected_Rule_level: any;
  Selected_Role: any;

  Is_Active: any;
  Amt_lmt: any;
  Ass_lvl: any;
  last_lvl: any;


  doa_type: any = "Approval";

  frmInvoice = new FormGroup({
    Workitem: new FormControl(''),
    Doatype: new FormControl('', [Validators.required]),
    doa_Matrix: new FormControl('', [Validators.required]),
    queue: new FormControl('', [Validators.required]),
    approved_queue: new FormControl('', [Validators.required]),
    rejected_queue: new FormControl('', [Validators.required]),
    Forward_queue: new FormControl(''),
    Rule_level: new FormControl('', [Validators.required]),
    Role: new FormControl('', [Validators.required]),
    Is_Active: new FormControl(''),
    Amt_lmt: new FormControl(''),
    Ass_lvl: new FormControl(''),
    last_lvl: new FormControl('')
  });

  // frmRulesave = new FormGroup({
  //   fieldselected: new FormControl('', [Validators.required]),
  //   txtdata: new FormControl('')
 // });
  //Comment section
  isCommentExpand: boolean = false;
  restrictedKeywords: any = [];
  transactionComment: string = "";
  wordsTotal: any = 1000;
  model: { DOA_Type: { type: string; value: number; label: string; multiple: number; options: { Id: number; Name: string; }[]; }; DOA_Matrix: { type: string; value: number; label: string; multiple: number; options: { Id: number; Name: string; }[]; }; processType: { type: string; value: number; label: string; multiple: number; options: { Id: number; Name: string; }[]; }; approved: { type: string; value: number; label: string; multiple: number; options: { Id: number; Name: string; }[]; }; rejected: { type: string; value: number; label: string; multiple: number; options: { Id: number; Name: string; }[]; }; forward: { type: string; value: number; label: string; multiple: number; options: { Id: number; Name: string; }[]; }; Rule: { type: string; value: number; label: string; multiple: number; options: { Id: number; Name: string; }[]; }; Role: { type: string; value: number[]; label: string; multiple: number; options: { Id: number; Name: string; }[]; }; Active: { type: string; value: number; label: string; checked: number; }; Amt_chk_lmt: { type: string; value: number; label: string; checked: number; }; Skip_Assign_lvl: { type: string; value: number; label: string; checked: number; }; last_lvl_mnd: { type: string; value: number; label: string; checked: number; }; };
  lstData: any;

  columnsToHide: any = "DOA_MATRIX_ID";
  hyperlinkCols: any = ['action_icon_Rule'];

  constructor(
    //private wowService: NgwWowService,
    private dataService: DataService,
    public commonService: CommonService,
    private dialog: MatDialog,
    private router: Router,
    private modalService: NgbModal,
    private encryptDecryptservice: EncryptDecryptService,
    private memorystore: MemoryStorageService,
    private fb: FormBuilder, private http: HttpClient) { }

  ngOnInit(): void {
    this.getDocumentTypes();
    this.DOATypes();
    this.getProcessTypes();
    this.getRole();
    this.DOAmatrix();
    this.Rulelevel();
// Initialize the form
    this.frmRulesave = this.fb.group({
      fieldselected: ['', Validators.required],
      txtdata: ['', Validators.required],
      csrfToken: ['', Validators.required] // Add a form control for CSRF token
    });
// Load the CSRF token from config.json
    this.http.get<{ csrfToken: string }>('/assets/config.json').subscribe((config) => {
      this.csrfToken = config.csrfToken;
      this.frmRulesave.patchValue({ csrfToken: this.csrfToken }); // Set the token in the form
    });
  
  }

  ngAfterViewInit() {
    this.showModal(this.documentTypeModal, 'sm');
  }
  DOAMatrixdata() {

    let param = {
      project_id: this.commonService.selectedProject,
      // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      user_id: this.memorystore.getItem('userId'),
      doc_id: this.selectedDocumentType.docTypeId
    }

    this.dataService.getData('get_DOAMatrixdata', param).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        this.lstData = res.data.Table
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }


  onGridCellClick(event: any) {

    var val = event.rowData.DOA_MATRIX_ID;
    // this.commonService.setUserInfoToLocalStorage('current_doc_id_doa', this.selectedDocumentType.docTypeId);
    // this.commonService.setUserInfoToLocalStorage('current_matrix_id_doa', val);
    this.memorystore.setItem('current_doc_id_doa', this.selectedDocumentType.docTypeId);
    this.memorystore.setItem('current_matrix_id_doa', val);
    this.router.navigate(['/create-doa-rule']);

  }
  showModal(modelTemplate, modalSize: string = 'lg') {
    this.modalReference = this.modalService.open(modelTemplate, {
      size: modalSize, centered: true, backdrop: 'static',
      keyboard: false
    });
  }

  async onChangeDoctype(docType: any) {
    this.isOpenDoctypeModel = false;
    this.selectedDocumentType = docType;
    this.getfield_names()
    this.modalReference.close();

    this.DOAMatrixdata()
  }


  submitInvoice() : void{
       if (this.frmRulesave.valid) {
      const formData = this.frmRulesave.value;

      // Validate the CSRF token before submission
      if (formData.csrfToken !== this.csrfToken) {
        alert('Invalid CSRF token');
        return;
      }

      console.log('Form submitted successfully', formData);
      // Proceed with form submission logic
    } else {
      alert('Form is invalid');
    }
  }
  saveDOAConfig() {

    debugger;
    let param = {
      doa_Type: this.selected_doa_Type.Name,
      doa_Matrix: this.selected_doa_Matrix.Name,
      queue: this.selected_queue.Id,
      approved_queue: this.selected_approved_queue.Id,
      rejected_queue: this.selected_rejected_queue.Id,
      forward_queue: this.selected_Forward_queue != undefined && this.selected_Forward_queue != null ? this.selected_Forward_queue.Id : 0,
      rule_level: this.Selected_Rule_level.Name,
      Role: this.Selected_Role.join(","),

      Is_Active: this.Is_Active != undefined && this.Is_Active != null ? Number(this.Is_Active) : 0,
      Amt_lmt: this.Amt_lmt != undefined && this.Amt_lmt != null ? Number(this.Amt_lmt) : 0,
      Ass_lvl: this.Ass_lvl != undefined && this.Ass_lvl != null ? Number(this.Ass_lvl) : 0,
      last_lvl: this.last_lvl != undefined && this.last_lvl != null ? Number(this.last_lvl) : 0,

      project_id: this.commonService.selectedProject,
      // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      user_id: this.memorystore.getItem('userId'),
      doc_type_id: this.selectedDocumentType.docTypeId

    }
    debugger;
    this.dataService.getData('save_DOA_matrix_config', param).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) { }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });

  }


  function(data) {

    this.wordsTotal = 1000 - data.length
  }
  onSelect_doa_Type(val) {
    this.doa_type = this.selected_doa_Type.Name
    this.getProcessTypes()
  }
  DOATypes() {
    this.doa_Typelist = [];
    this.doa_Typelist.push({ Id: 1, Name: "Approval" })
    this.doa_Typelist.push({ Id: 2, Name: "Query" })
  }
  Rulelevel() {
    this.doa_Rulelevellist = [];
    this.doa_Rulelevellist.push({ Id: 1, Name: "Header" })
    this.doa_Rulelevellist.push({ Id: 2, Name: "Line" })

  }
  DOAmatrix() {
    this.doa_matrixlist = [];
    this.doa_matrixlist.push({ Id: 1, Name: "Open Manual Selection" })
    this.doa_matrixlist.push({ Id: 2, Name: "Sequential" })
    this.doa_matrixlist.push({ Id: 3, Name: "Parallel" })
    this.doa_matrixlist.push({ Id: 4, Name: "Straight Through Ladder" })

  }
  getDocumentTypes() {

    this.docTypeList = [];
    let params = new HttpParams();
    // params = params.append('project_id', this.commonService.selectedProject);
    // params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    params = params.append('subgroup_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedSubgroup));
    params = params.append('action', 'manual creation');
    params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));
    this.dataService
      .getData('document-types', params)
      .subscribe(
        (res) => {
          if (res != null && (res.error_message == null || res.error_message == "")) {
            if (res.data != null) {
              this.documentType_MST = res.data;
              for (var i = 0; i < res.data.length; i++) {
                this.docTypeList.push({
                  docTypeId: res.data[i].document_type_id,
                  docTypeName: res.data[i].document_type_name,
                  isCommentMandatory: res.data[i].is_comment_mandatory_for_create_workitem
                });
              }
              //   this.showModal(this.documentTypeModal, 'sm');
            }
          }
          else {
            if (res.errorCode != 0 && res.errorCode == 4000) {
              this.router.navigateByUrl('/unauthorized');
              return;
            }
            if (res.errorCode != 0 && res.errorCode == 3000) {
              this.commonService.showMessageBox("Internal error")
            }
          }

        },
        error => {
          if (error.includes("401")) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
        }
      );
  }
  getProcessTypes() {
    var val = "'" + this.doa_type + "'"
    this.processTypeList = [];

    this.processTypeList_appr = [];
    this.processTypeList_rej = [];
    this.processTypeList_forwd = [];

    let params = new HttpParams();
    params = params.append('project_id', this.commonService.selectedProject);
    params = params.append('Queuename', val) // 'APPROVAL','QUERY'
    this.dataService.getData('process-type_DOA', params).subscribe(
      (res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res != null && res.data.Table != null) {

            for (var i = 0; i < res.data.Table.length; i++) {
              this.processTypeList.push({
                Id: res.data.Table[i].process_id,
                Name: res.data.Table[i].process_name,
              });
            }
          }

          if (res != null && res.data.Table1 != null) {

            for (var i = 0; i < res.data.Table1.length; i++) {
              this.processTypeList_appr.push({
                Id: res.data.Table1[i].PROCESS_ID,
                Name: res.data.Table1[i].PROCESS_NAME,
              });
            }
          }
          if (res != null && res.data.Table2 != null) {

            for (var i = 0; i < res.data.Table2.length; i++) {
              this.processTypeList_rej.push({
                Id: res.data.Table2[i].PROCESS_ID,
                Name: res.data.Table2[i].PROCESS_NAME,
              });
            }
          }
          if (res != null && res.data.Table3 != null) {

            for (var i = 0; i < res.data.Table3.length; i++) {
              this.processTypeList_forwd.push({
                Id: res.data.Table3[i].PROCESS_ID,
                Name: res.data.Table3[i].PROCESS_NAME,
              });
            }
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }


      },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  getfield_names() {
    this.fieldList = [];
    let params = new HttpParams();
    params = params.append('project_id', this.commonService.selectedProject);
    params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    params = params.append('doc_type_id', this.selectedDocumentType.docTypeId);

    this.dataService.getData('getfield_names_DOA', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.data.Table != null) {
          for (var i = 0; i < res.data.Table.length; i++) {
            this.fieldList.push({
              Id: res.data.Table[i].id,
              Name: res.data.Table[i].name,
            });
          }
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }

    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  getRole() {

    this.RoleList = [];
    let params = new HttpParams();
    params = params.append('project_id', this.commonService.selectedProject);
    params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    params = params.append('process_id', this.selectedProcess);
    params = params.append('doc_type_id', this.selectedDocumentType.docTypeId);
    params = params.append('pwm_id', 0);
    params = params.append('Is_Manager_flag', 0);
    this.dataService.getData('roles_DOA', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.data.Table != null) {
          for (var i = 0; i < res.data.Table.length; i++) {
            this.RoleList.push({
              Id: res.data.Table[i].id,
              Name: res.data.Table[i].name,
            });
          }
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }

    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }



}
